import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../../../app/guards'
import { EditContractPage } from '../../../../../features/contracts/contract-form-page'

export const Route = createFileRoute('/_app/service/contracts/$contractId/edit')({
  staticData: { crumb: 'serviceContractEdit' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'contracts.manage'),
  component: EditContractPage,
})
